import { ReactComponent as CheckSvg } from '../assets/check.svg';

export const DisabledButton: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <button
      disabled
      className="bg-contrast-7 dark:bg-contrast-2 text-contrast-6 dark:text-contrast-5 h-12 px-8 rounded-lg text-[14px] font-semibold font-inter cursor-not-allowed opacity-50 w-full md:w-auto flex items-center justify-center"
    >
      {children}
    </button>
  );
};

export const Button: React.FC<React.ButtonHTMLAttributes<HTMLButtonElement>> = ({
  children,
  ...props
}) => {
  return (
    <button
      {...props}
      className={
        'bg-primary-papaya hover:bg-opacity-90 text-white h-12 px-8 rounded-lg text-[14px] font-semibold font-inter transition-all shadow-[0_2px_12px_0_rgba(255,158,0,0.20),0_0_14px_0_rgba(255,158,0,0.60)_inset,0_0_16px_0_rgba(90,63,229,0.15)] w-full md:w-auto flex items-center justify-center ' +
        (props.className || '')
      }
    >
      {children}
    </button>
  );
};

export const PrimaryButton: React.FC<React.ButtonHTMLAttributes<HTMLButtonElement>> = ({
  children,
  ...props
}) => {
  return (
    <button
      {...props}
      className="bg-primary-azul hover:bg-opacity-90 hover:shadow-none text-white font-medium font-inter text-[14px] rounded-[8px] transition-all shadow-[0_2px_12px_0_rgba(123,138,255,0.10),0_0_14px_0_rgba(118,133,255,0.50)_inset,0_0_16px_0_rgba(90,63,229,0.15)] flex items-center justify-center px-6 py-2.5 min-w-[120px]"
    >
      {children}
    </button>
  );
};

export const SecondaryButton: React.FC<React.ButtonHTMLAttributes<HTMLButtonElement>> = ({
  children,
  ...props
}) => {
  const isDisabled = props.disabled;
  return (
    <button
      {...props}
      className={
        'px-6 py-2.5 rounded-lg text-sm font-medium font-inter transition-all text-contrast-5 dark:text-contrast-7 bg-contrast-8 dark:bg-contrast-3 min-w-[120px] flex items-center justify-center ' +
        (isDisabled
          ? 'opacity-50 cursor-not-allowed'
          : 'cursor-pointer hover:bg-contrast-7 dark:hover:bg-contrast-1')
      }
    >
      {children}
    </button>
  );
};

export const ButtonWithCheck: React.FC<React.ButtonHTMLAttributes<HTMLButtonElement>> = ({
  children,
  ...props
}) => {
  return (
    <button
      {...props}
      style={{ background: '#34CA9A' }}
      className={
        'absolute right-1 top-1 h-10 w-12 flex items-center justify-center rounded-md hover:bg-opacity-90 transition-all' +
        (props.className || '')
      }
    >
      <CheckSvg />
    </button>
  );
};
